import Vue from 'vue';

Vue.directive('loadmore', { bind (el, binding) {
		// const selectWrap = el.querySelector('.el-table__body-wrapper');
		const selectWrap = el;
		selectWrap.addEventListener('scroll', function() {
			
			let sign = 100;
			const scrollDistance = this.scrollHeight - this.scrollTop - this.clientHeight;
			if (scrollDistance <= sign) {
				//console.log(scrollDistance, sign,binding.value())
				console.log(scrollDistance, sign)
				binding.value();
			}
		});
	}
});
